export const PostTypes = {
	post: 1,
	research_brief: 2,
};
